import React from 'react';
import './NotFound.css';
import Header from "./common/Header";
import {Footer} from "./common/Footer";
import {Link} from "react-router-dom"; // Add custom styling here

const NotFound = () => {
    return (
        <>
            <Header />
            <div className="not-found-container">
                <p>Cейчас в этом разделе нет товаров. Но мы уже работаем над наполнением!</p>
                <Link className={'link'} to={'/home'}>
                    <button className={'section-button'}>Перейти к покупкам</button>
                </Link>
            </div>
            <Footer/>
        </>
    );
};

export default NotFound;
